import { filter } from "lodash";
import { data } from "./weightLossData";

export function getChartData(sex, bmi, desiredWeightChange) {
  let bmiBin;
  switch (true) {
    case bmi >= 18.5 && bmi < 25:
      bmiBin = "healthy";
      break;
    case bmi >= 25 && bmi < 30:
      bmiBin = "overweight";
      break;
    case bmi >= 30 && bmi < 35:
      bmiBin = "obese1";
      break;
    case bmi >= 35 && bmi < 40:
      bmiBin = "obese2";
      break;
    case bmi >= 40:
      bmiBin = "obese3";
      break;
  }

  let results = filter(data, { sex: sex, bmi_bin: bmiBin }).map(week => {
    return week.median_wc_lbs;
  });
  let estimatedWeightChange = 0;

  if (results.length) {
    const resultsRounded = results.map(week => {
      return Math.abs(Math.round(week));
    });
    // Remove weeks after max weight loss or goal weight is met.
    const maxLoss = Math.max(...resultsRounded);
    estimatedWeightChange = Math.min(desiredWeightChange, maxLoss);
    results = results.slice(
      0,
      resultsRounded.findIndex(week => week >= estimatedWeightChange) + 1
    );
  }

  return { estimatedWeightChange, results };
}
